import FroalaEditor from 'froala-editor';

// 定義自定義按鈕和選擇框
FroalaEditor.DefineIcon('customSelect', {
    SRC: 'https://assets.fevercdn.com/nc/froala_editor/add_select.png',
    ALT: 'fr-custom icon-select',
    template: 'image'
});
FroalaEditor.RegisterCommand('customSelect', {
    title: '插入變數',
    type: 'dropdown',
    focus: true,
    undo: true,
    refreshAfterCallback: true,
    options: {
        remainDays: '活動剩餘天數',
        // availablePrizes: '獎品剩餘數量',
        entryCount: '活動參加人數'
    },
    callback: function (cmd, val) {
        this.html.insert(`{{onsite:${val}}}`);
    }
});
